import { useFamilyIndexByBrand } from "queries/family";
import { useActiveShopGridByShop, useShopGridShow } from "queries/shop_grid";
import { useNavigate, useParams } from "react-router-dom";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import ShopInventoryProposal from "./ShopInventoryProposal";
import { useShopShow } from "queries/shops";
import BreadCrumbShop from "../index/BreadCrumbShop";
import { Typography } from "@mui/material";

const ShopInventoryProposalPage = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { erpId, proposalId } = useParams<{ erpId: string; proposalId: string }>();
  const { data: shop , isLoading: isLoadingShop} = useShopShow(erpId!);
  const { data: activeGrid, isLoading: isLoadingGrid } = useActiveShopGridByShop(shop);
  const { data: gridProposal, isLoading: isLoadingProposal } = useShopGridShow(Number.parseInt(proposalId!));
  const { data: families = [], isFetching: isFetchingFamilies } = useFamilyIndexByBrand(shop?.brandId);
  const { t } = useTranslation();
  const navigate = useNavigate();
  if (isLoadingGrid || isFetchingFamilies || isLoadingProposal || isLoadingShop) return null;
  return (<>
    <Typography component="h1" variant="h6" sx={{ mb: 1 }}>
      {t("shop.index.propose")}
    </Typography>
    <BreadCrumbShop shop={shop} label="shop.index.propose" />
    <ShopInventoryProposal
      activeGrid={activeGrid!}
      families={families}
      gridProposal={gridProposal!}
      onProposalApplied={() => {
        enqueueSnackbar(t("shop.inventory_proposal.applySuccess"), { variant: "success" });
        navigate(`/shops/${erpId}/inventory`);
      }}
    />
  </>);
};

export default ShopInventoryProposalPage;
